define("Bazaarvoice.PDP.RatingSummary.View", [
  "SCView",
  "bazaarvoice_pdp_rating_summary.tpl",
  "underscore",
], function (SCViewComponent, bazaarvoice_pdp_rating_summary_tpl, _) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function BazaarvoicePDPRatingSummaryView(options) {
    SCView.call(this);

    this.options = options || {};
    this.container = this.options.container;
    this.template = bazaarvoice_pdp_rating_summary_tpl;
    this.pdp = this.container.getComponent("PDP");

    // For matrix selection
    this.pdp.cancelableOn("afterOptionSelection", _.bind(this.render, this));
  }

  BazaarvoicePDPRatingSummaryView.prototype = Object.create(SCView.prototype);

  BazaarvoicePDPRatingSummaryView.prototype.constructor =
    BazaarvoicePDPRatingSummaryView;

  BazaarvoicePDPRatingSummaryView.prototype.getItem = function () {
    var iteminfo = this.pdp && this.pdp.getItemInfo();

    if (!iteminfo) {
      return {};
    }

    var selectedMatrixChilds = this.pdp.getSelectedMatrixChilds();
    var matrixSelected =
      !!_.size(selectedMatrixChilds) && _.first(selectedMatrixChilds);

    return matrixSelected ? matrixSelected : iteminfo.item || {};
  };

  BazaarvoicePDPRatingSummaryView.prototype.getContext = function () {
    var item = this.getItem();

    return {
      productId: item.itemid,
    };
  };

  return BazaarvoicePDPRatingSummaryView;
});
